import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';

@Component({
  selector: 'lib-assistant-system-message',
  standalone: true,
  imports: [TranslateModule, SvgIconComponent],
  templateUrl: './assistant-system-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantSystemMessageComponent {}
